(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-card-picker-mini"] && !Shopify.designMode) return;
  try {
    class VariantCardPickerMini extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('.vcpm__input').forEach((input) => {
      input.addEventListener('change', this._onChange.bind(this));
    });
  }

  _onChange(event) {
    const id = event.target.value;
    const sectionId = this.dataset.sectionId;

    this.querySelectorAll('.vcpm__item').forEach((item) => {
      item.classList.toggle('vcpm__item--selected', item.dataset.variantId === id);
    });

    const url = new URL(window.location.href);
    url.searchParams.set('variant', id);
    window.history.replaceState({}, '', url.toString());

    const form = document.getElementById(`BuyButtons-ProductForm-${sectionId}`);
    if (form) {
      const variantInput = form.querySelector('input[name="id"]');
      if (variantInput) variantInput.value = id;
    }

    this.dispatchEvent(new CustomEvent('variant:changed', {
      bubbles: true,
      detail: {
        variant: { id: parseInt(id) },
        sectionId: sectionId,
      },
    }));
  }
}

if (!customElements.get('variant-card-picker-mini')) {
  customElements.define('variant-card-picker-mini', VariantCardPickerMini);
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    class VariantCardPicker extends HTMLElement {
  constructor() {
    super();
    this.inputs = this.querySelectorAll('.variant-card__input');
    this.cards  = this.querySelectorAll('.variant-card');
  }

  connectedCallback() {
    this.inputs.forEach((input) => {
      input.addEventListener('change', this.onVariantChange.bind(this));
    });
  }

  getVariantData() {
    if (!this.variantData) {
      this.variantData = JSON.parse(
        this.querySelector('[type="application/json"]').textContent
      );
    }
    return this.variantData;
  }

  onVariantChange(event) {
    const selectedVariantId = event.target.value;

    // Update card selection styles
    this.cards.forEach((card) => {
      card.classList.toggle(
        'variant-card--selected',
        card.dataset.variantId === selectedVariantId
      );
    });

    // Update URL without reloading
    const url = new URL(window.location.href);
    url.searchParams.set('variant', selectedVariantId);
    window.history.replaceState({}, '', url.toString());

    // Update the product form hidden variant input
    const variantInput = document.querySelector(
      `form[action="/cart/add"] input[name="id"]`
    );
    if (variantInput) {
      variantInput.value = selectedVariantId;
    }

    // Fallback: some themes use variant_id instead of id
    document.querySelectorAll('input[name="variant_id"]').forEach((input) => {
      input.value = selectedVariantId;
    });

    // Dispatch variant:changed so Horizon updates price, images, ATC state
    this.dispatchEvent(
      new CustomEvent('variant:changed', {
        bubbles: true,
        detail: {
          variant: { id: parseInt(selectedVariantId) },
          sectionId: this.dataset.sectionId,
        },
      })
    );
  }
}

if (!customElements.get('variant-card-picker')) {
  customElements.define('variant-card-picker', VariantCardPicker);
}
  } catch(e) { console.error(e); }
})();

})();
